const productunit = {
    getlist: 'productunit/getlist',
    add: 'productunit/add',
    update: 'productunit/update',
    remove: 'productunit/remove',
    get: 'productunit/get',
    getall: 'productunit/getall',
    clearcache: 'productunit/clear-cache',
}
export default productunit
